import { SupportTicket } from '@zenstackhq/runtime/models'
import { useMemo } from 'react'
import { Api } from '~/core/trpc'

type Props = {
  ticket: SupportTicket
}

export const useData = ({ ticket }: Props) => {
  const ticketId = ticket.id

  const conversationQuery = Api.chatConversation.findFirst.useQuery({
    where: {
      supportTicket: {
        id: ticketId,
      },
    },
    include: {
      participants: {
        include: {
          organizationContact: true,
        },
      },
    },
  })

  const messagesQuery = Api.chatMessage.findMany.useQuery(
    {
      where: {
        conversationId: ticketId,
      },
      orderBy: {
        createdAt: 'desc',
      },
    },
    { initialData: [] },
  )

  const contact = useMemo(() => {
    const participant = conversationQuery.data?.participants?.find(
      participant => !!participant.organizationContact,
    )

    return participant?.organizationContact
  }, [conversationQuery.data?.participants])

  const refetch = () => {
    return conversationQuery.refetch()
  }

  return {
    conversation: conversationQuery.data,
    ticket,
    contact,
    messages: messagesQuery.data,
    refetch,
  }
}

export type DataType = ReturnType<typeof useData>['ticket']
